import { mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import StarRating from 'vue-star-rating';
import { routeToProduct } from '@/helpers';
import { MEDIA } from '@/helpers/variables';

import IconArrowPrevLight from '@/components/icons/IconArrowPrevLight.vue';
import IconArrowNextLight from '@/components/icons/IconArrowNextLight.vue';
import ImageCard from '@/components/@general/ImageCard/index.vue';
import ReviewClientCard from '@/components/cards/ReviewClientCard/index.vue';

export default {
  name: 'HomeFeedbacks',
  components: {
    ReviewClientCard,
    ImageCard,
    IconArrowNextLight,
    IconArrowPrevLight,
    Carousel,
    Slide,
    StarRating
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      MEDIA,
      step: 2
    };
  },

  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      appSize: 'app/size'
    }),
    listFeedbacks: function () {
      return this.data.slice(0, this.step);
    },
    isShowFeedbacksSliderArrows: function () {
      return this.data.length > 4;
    },
    isHasMore: function () {
      return this.step < this.data.length;
    }
  },
  methods: {
    routeToProduct: routeToProduct,
    onLoadMore() {
      this.step += 2;
    },

    onClickNav(direction) {
      let carousel = this.$refs.homeFeedbacksRef;
      if (carousel) {
        carousel.advancePage(direction);
      }
    }
  }
};
